import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Icon from '../index.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'dot',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Icon, {
    style: {"transform":"scale(0.3)"},
    name: "dot",
    viewBox: "0 0 4 4"
  }))
}
}

})